export const errorValidations = {
  earlyDate: "The end date must be later than the start date",
};
